import { Component } from '@angular/core';

@Component({
  selector: 'app-api-fluid-loss-vertical-header',
  standalone: false,
  templateUrl: './api-fluid-loss-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class ApiFluidLossVerticalHeaderComponent{
}
